export const defaultMarker = "#007cbf";
export const defaultActiveMarker = "#ff0000";
